import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function DevopsProcessIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 36 36" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M18.9393 16.9392C19.5251 16.3534 20.4749 16.3534 21.0607 16.9392V16.9392C21.6464 17.525 21.6464 18.4747 21.0607 19.0605L16.1109 24.0103C15.5251 24.5961 14.5754 24.5961 13.9896 24.0103V24.0103C13.4038 23.4245 13.4038 22.4747 13.9896 21.8889L18.9393 16.9392Z"
        fill="#927BF0"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M21.0604 16.9392C21.6462 17.525 21.6462 18.4748 21.0604 19.0605V19.0605C20.4746 19.6463 19.5249 19.6463 18.9391 19.0605L13.9894 14.1108C13.4036 13.525 13.4036 12.5753 13.9894 11.9895V11.9895C14.5752 11.4037 15.5249 11.4037 16.1107 11.9895L21.0604 16.9392Z"
        fill="#927BF0"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M10.5 16C11.3284 16 12 16.6716 12 17.5V17.5C12 18.3284 11.3284 19 10.5 19L4.5 19C3.67157 19 3 18.3284 3 17.5V17.5C3 16.6716 3.67157 16 4.5 16L10.5 16Z"
        fill="#CCBFFF"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M31.6216 16C32.45 16 33.1216 16.6716 33.1216 17.5V17.5C33.1216 18.3284 32.45 19 31.6216 19L25.6216 19C24.7932 19 24.1216 18.3284 24.1216 17.5V17.5C24.1216 16.6716 24.7932 16 25.6216 16L31.6216 16Z"
        fill="#CCBFFF"
      />
    </svg>
  );
};
